import { cn } from "@/lib/utils";
import { willSrc } from "@/lib/preloadWill";

interface SaveyLoaderProps {
  /** Full-screen overlay (default) or inline block */
  fullscreen?: boolean;
  /** Optional message under the loader */
  message?: string;
  className?: string;
}

/**
 * Branded loader featuring Will the pig with a "Loading" label.
 * Uses a preloaded in-memory image for instant render.
 */
export const SaveyLoader = ({
  fullscreen = true,
  message = "Loading",
  className,
}: SaveyLoaderProps) => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn(
        fullscreen
          ? "fixed inset-0 z-[100] flex items-center justify-center bg-background/60 backdrop-blur-sm"
          : "flex items-center justify-center py-6",
        className
      )}
    >
      <div className="flex flex-col items-center gap-2">
        <img
          src={willSrc}
          alt="Will the pig"
          width={64}
          height={64}
          decoding="sync"
          // @ts-ignore
          fetchpriority="high"
          className="h-16 w-16 object-contain animate-bounce drop-shadow-lg"
          style={{ animationDuration: "0.6s" }}
        />
        <div
          className="h-6 w-6 rounded-full border-[3px] border-white/10 border-t-primary animate-spin"
          style={{ animationDuration: "0.5s" }}
        />
        <span className="text-sm font-semibold text-foreground tracking-wide">
          {message}
          <span className="inline-block animate-pulse">…</span>
        </span>
      </div>
      <span className="sr-only">Loading SaveySpend…</span>
    </div>
  );
};

export default SaveyLoader;
